var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tender-representative" },
    [
      _c(
        "div",
        { staticClass: "tender-representative-content" },
        [
          _c("div", { staticClass: "contractor-info-head clearfix " }, [
            _c("div", { staticClass: "top-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("tender.representatives")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.isPicView
              ? _c("div", { staticClass: "contractor-info-buttons" }, [
                  !_vm.editable
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn--darkblue",
                          attrs: {
                            type: "button",
                            disabled: !_vm.canEditRepresentative,
                          },
                          on: {
                            click: function () {
                              return _vm.enableEdit()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("action.edit")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editable
                    ? _c(
                        "button",
                        {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          staticClass: "btn btn--darkblue",
                          attrs: { type: "button" },
                          on: {
                            click: function () {
                              return _vm.cancel()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("action.cancel")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editable
                    ? _c(
                        "button",
                        {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          staticClass: "btn btn--orange",
                          attrs: { type: "button" },
                          on: {
                            click: function () {
                              return _vm.save()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("action.save")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.editable
            ? _c(
                "div",
                { staticClass: "editabel input-areas" },
                [
                  _vm._l(_vm.accounts, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "content" },
                      [
                        _c(
                          "div",
                          { staticClass: "name" },
                          _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                            return _c("InputField", {
                              key: fullnameObj.key,
                              attrs: {
                                label:
                                  !index && fullnameObj.isFirst
                                    ? _vm.$t("name")
                                    : "",
                                placeholder: _vm.$t(
                                  "contact.basic." + fullnameObj.label
                                ),
                                value:
                                  item.tenderAccount[
                                    "contact" + fullnameObj.key
                                  ],
                                required: true,
                              },
                              on: {
                                updateValue: function (val) {
                                  return _vm.updateContactAttr(
                                    "contact" + fullnameObj.key,
                                    val,
                                    index
                                  )
                                },
                              },
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("InputField", {
                          staticClass: "email",
                          class: _vm.emailErrClass(index),
                          attrs: {
                            label: !index ? _vm.$t("user.email") : "",
                            placeholder: "",
                            showColon: false,
                            value: item.username,
                            inputTip: _vm.$t("hint.inputTip.email"),
                            pattern: _vm.regex.email,
                            required: "",
                          },
                          on: {
                            updateValue: function (val) {
                              return _vm.updateContactUsername(val, index)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("InputField", {
                          staticClass: "phone",
                          class: _vm.phoneErrClass(index),
                          attrs: {
                            label: !index
                              ? _vm.$t("contact.phone.primaryPhone")
                              : "",
                            placeholder: "",
                            showColon: false,
                            value: item.tenderAccount.phone,
                            required: "",
                          },
                          on: {
                            updateValue: function (val) {
                              return _vm.updateContactAttr("phone", val, index)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("InputField", {
                          staticClass: "alt-phone",
                          class: _vm.phoneErrClass(index),
                          attrs: {
                            label: !index ? _vm.$t("user.altPhone") : "",
                            placeholder: "",
                            showColon: false,
                            showFlag: false,
                            value: item.tenderAccount.altPhone,
                          },
                          on: {
                            updateValue: function (val) {
                              return _vm.updateContactAttr(
                                "altPhone",
                                val,
                                index
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-times",
                          on: {
                            click: function ($event) {
                              return _vm.preDeleteAccount(index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.showAddBtn
                    ? _c(
                        "span",
                        {
                          staticClass: "addAccount",
                          on: { click: _vm.addAccount },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("action.addRepresentative")) + "+"
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              )
            : _c(
                "ul",
                { class: ["display-table", { creator: _vm.showInviteBtn }] },
                [
                  _c("div", { staticClass: "table-header" }, [
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.$t("name"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "email" }, [
                      _vm._v(_vm._s(_vm.$t("user.email"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "phone" }, [
                      _vm._v(_vm._s(_vm.$t("contact.phone.primaryPhone"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "other-phone" }, [
                      _vm._v(_vm._s(_vm.$t("user.altPhone"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "lastlogin" }, [
                      _vm._v(_vm._s(_vm.$t("lastLogin"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "invited-at" }, [
                      _vm._v(_vm._s(_vm.$t("invitedAt"))),
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showInviteBtn,
                          expression: "showInviteBtn",
                        },
                      ],
                      staticClass: "invite",
                    }),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.accounts, function (item, index) {
                    return _c(
                      "li",
                      { key: index, staticClass: "table-content" },
                      [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.displayFullName(
                                item.tenderAccount.contactFirstName,
                                item.tenderAccount.contactLastName
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "email" }, [
                          _vm._v(_vm._s(item.username)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "phone" }, [
                          _vm._v(
                            _vm._s(
                              item.tenderAccount.phone || _vm.$t("emptyValue")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "phone" }, [
                          _vm._v(
                            _vm._s(
                              item.tenderAccount.altPhone ||
                                _vm.$t("emptyValue")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "lastlogin" }, [
                          _vm._v(_vm._s(_vm.formatDate(item.lastLoginAt))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "invited-at" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(item.tenderAccount.invitedAt) ||
                                "-"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showInviteBtn,
                                expression: "showInviteBtn",
                              },
                            ],
                            staticClass: "invite",
                            style: {
                              visibility: _vm.isCurrentUser(item)
                                ? "hidden"
                                : "visible",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "invite-btn btn btn--orange",
                                on: {
                                  click: function ($event) {
                                    return _vm.invite(item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s("invite"))]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
          _vm._v(" "),
          _c(
            "Modal",
            {
              ref: "confirm-delete-representative",
              attrs: {
                showCloseBtn: false,
                modalId: "duplicate-representative-" + +new Date(),
              },
            },
            [
              _c("div", { staticClass: "font-bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("hint.deleteTenderRepresentative")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    on: { click: _vm.closeDeleteConfirmModal },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("action.cancel")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    on: { click: _vm.doDelete },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("action.confirm")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("HKLInviteModal", {
        ref: "inviteModal",
        attrs: {
          listTitle: _vm.$t("tender.representatives"),
          accountsList: _vm.needInviteAccounts,
        },
        on: {
          onInviteClick: function () {
            return _vm.invite(_vm.needInviteAccounts)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }